export class ConfigDB {
    static data = {
      settings: {
        layout_type: 'ltr',
        layout_class: 'compact-wrapper modern-type',
        sidebar: {
          iconType: 'stroke',
        },
        sidebar_setting: 'default-sidebar',
      },
      color: {
        primary_color:'#6271EB',
        secondary_color: '#FF8575',
        mix_background_layout: 'dark-sidebar',
      }
    };
  }
  export default ConfigDB;